import React, { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { useSelector } from 'react-redux';
import { aiAlertsMetricsMetaSelector } from '@src/store/common/selectors';
import Retry from '@components/common/Retry';
import metricsStore from '@globalStore/metricsStore';
import useSensitivity from '@src/components/aiAlerts/hooks/useSensitivity';
import { fullSensitivityConfigAtom } from './atoms';
import { getDefaultMetricsSensitivityConfig } from '@src/utils/aiAlerts/metrics';
import SensitivityDrawer from './SensitivityDrawer';

const filterDeletedMetricsFromSensitivity = (aiAlertsMetricsMeta, activeMetricsKeys) => {
  const filteredMetricsMeta = aiAlertsMetricsMeta.filter(
    (metricMeta) => metricMeta.isCustom || !activeMetricsKeys.app.includes(metricMeta.key),
  );
  return filteredMetricsMeta;
};

const SensitivityControl = (props) => {
  const { data: sensitivityData, isFetching, isError, refetch } = useSensitivity();
  const combinedMetricsKey = metricsStore.getState().combinedMetricsKey;
  const aiAlertsMetricsMeta = useSelector(aiAlertsMetricsMetaSelector);
  const setFullSensitivityData = useSetAtom(fullSensitivityConfigAtom);

  useEffect(() => {
    if (sensitivityData) {
      const filterDeletedMetricsMeta = filterDeletedMetricsFromSensitivity(
        aiAlertsMetricsMeta,
        combinedMetricsKey,
      );
      const sensitivityConfigs = getDefaultMetricsSensitivityConfig(
        sensitivityData,
        filterDeletedMetricsMeta,
      );
      setFullSensitivityData(sensitivityConfigs);
    }
  }, [sensitivityData]);

  if (isFetching) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error...</div>;
  }

  return (
    <Retry isLoading={isFetching} showError={isError} fetchData={refetch}>
      <SensitivityDrawer {...props} />
    </Retry>
  );
};

export default SensitivityControl;
